import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface UploadFileResponse {
    id: string;
    uploadedAt: string;
    uploadedBy: string;
    mimeType: string;
}

interface Input {
    file: File;
}

export function useUploadFileMutation() {
    return useMutation({
        mutationFn: async (input: Input): Promise<UploadFileResponse> => {
            const formData = new FormData();
            formData.append("file", input.file);

            const res = await apiClient.uploadFile({
                body: formData,
            });

            if (res.status !== 200) {
                throw new Error("Error uploading file");
            }

            return res.body;
        },
    });
}
